<mat-card>
  <mat-card-header>
    <mat-card-title>Position(s) to be Sponsored</mat-card-title>
  </mat-card-header>

  <mat-card-content class="m-t-1">
    
        <app-radio-input 
                label="Do you know the details of the jobs/positions that the business wants to sponsor?" 
                [control]="positionsForm.controls.knowPositions" 
                [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]"
                [submitAttempted]="submitAttempted"
                [errorMsg]="'Do you know the details is required'"
                >
          </app-radio-input>


      @if (model.employerSponsor!.knowPositions == 'true') {
        <div class="section-label">
          <mat-label>List all positions</mat-label>
        </div>

        @if (model.employerSponsor!.positions.length > 0) {
          @if(!(isMobile$ | async)) {
          <table mat-table [dataSource]="positionsDataSource" class="mat-elevation-z1">
            <ng-container matColumnDef="jobTitle">
              <th mat-header-cell *matHeaderCellDef>Job Title</th>
              <td mat-cell *matCellDef="let element">{{element.jobTitle}}</td>
            </ng-container>

            <ng-container matColumnDef="salary">
              <th mat-header-cell *matHeaderCellDef>Salary</th>
              <td mat-cell *matCellDef="let element">{{element.salary}}</td>
            </ng-container>
            
            <ng-container matColumnDef="applicant">
              <th mat-header-cell *matHeaderCellDef>Applicant</th>
              <td mat-cell *matCellDef="let element">{{getApplicantName(element)}}</td>
            </ng-container>

            <ng-container matColumnDef="edit">
              <th mat-header-cell *matHeaderCellDef>Edit</th>
              <td mat-cell *matCellDef="let element; let i = index">
                <button mat-icon-button (click)="edit(i)">
                  <mat-icon>edit</mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="delete">
              <th mat-header-cell *matHeaderCellDef>Delete</th>
              <td mat-cell *matCellDef="let element; let i = index">
                <button mat-icon-button color="warn" (click)="remove(i)">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        }
        @if(isMobile$ | async) {
          <div class="mobile-cards">
        @for(position of model.employerSponsor!.positions; track position; let i = $index) {
        <mat-card  class="mobile-card">
          <mat-card-content>
            <div class="mobile-card-details">
              <div class="mobile-card-item">
                <span class="label">Job Title:</span>
                <span class="value">{{position.jobTitle}}</span>
              </div>
              <div class="mobile-card-item">
                <span class="label">Salary:</span>
                <span class="value">{{position.salary}}</span>
              </div>
            <div class="mobile-card-item">
                <span class="label">Applicant:</span>
                <span class="value">{{getApplicantName(position)}}</span>
              </div>      
            </div>
            <div class="mobile-card-actions">
              <button mat-stroked-button (click)="edit(i)" class="action-button">
                <mat-icon>edit</mat-icon>
                Edit
              </button>
              <button mat-stroked-button color="warn" (click)="remove(i)" class="action-button">
                <mat-icon>delete</mat-icon>
                Delete
              </button>
            </div>
          </mat-card-content>
        </mat-card>
  
      }
    </div>
        }
      }
        <button mat-raised-button color="primary" (click)="add()">Add position(s)</button>
      }
  </mat-card-content>
</mat-card>